import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ImEqualizer2 } from 'react-icons/im'
import { IoTrashSharp } from 'react-icons/io5'
import { VscFilter } from 'react-icons/vsc'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import PropFilter from '../../components/Modal/PropFilter'
import { eventFilters } from '../slice/createEventSlice'

const Filter = () => {


    const dispatch = useDispatch()
    const history = useHistory()
    // const eventId   = history.location.state
    const [propFilterItem, setPropFilter] = useState([])
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const { event_option, filters, eventId } = useSelector(state => state.createEvent)
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)

    const quotationLoader = {
        position: 'fixed',
        zIndex: '1000',
        background: 'rgba(255,255,255, 0.78)',
        width: '100%',
        height: '100vh',
        top: '0',
        left: '0',
        display: 'grid',
        alignItems: 'center',
        textAlign: 'center',
    }

    const handelFilter = async (e, data) => {
        e.preventDefault();
        dispatch(eventFilters(propFilterItem))
        setLoading(true)
        http.post("event-filter", { option_filters: propFilterItem, eventId }).then(res => {
            if (res.data.filters === 'success') {
                if (event_option) {
                    if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                    else { history.push('/event/summary', eventId) }
                }
                setLoading(false)
            }
        }).catch()

    }

    useEffect(() => {
        if (filters) {
            if (filters.length > 0) {
                setPropFilter(filters)
            }
        }
    }, [filters])


    const setPropFilterByProps = (data) => {
        setPropFilter(data)
    }

    const removeProps = (id) => {
        let copyProps = [...propFilterItem]
        copyProps.splice(id, 1)
        setPropFilter(copyProps)
    }

    const saveAsDraft = () => {
        dispatch(eventFilters(propFilterItem))
        setDraftLoading(true)
        http.post("event-filter", { option_filters: propFilterItem, eventId }).then(res => {
            if (res.data.filters === 'success') {
                setDraftLoading(false)
            }
        }).catch(err => setDraftLoading(false))
    }

    
    const BackToPreviousPage = (e) => {
        e.preventDefault()
        if (event_option.incentive_offer === true) { history.push('/event/incentive-offer') }
        else if (event_option.boomerang_frame_option === true) { history.push('/event/boomerang-frame') }
        else if (event_option.video_frame_option === true) { history.push('/event/video-frame') }
        else if (event_option.frame_option   === true) { history.push('/event/frame') }
        else if (event_option.microsite      === true) { history.push('/event/microsite') }
        else if (event_option.water_mark     === true) { history.push('/event/custom-branding') }
        else if (event_option.digital_props  === true) { history.push('/event/digital-prop') }
        else if (event_option.text_messaging === true) { history.push('/event/sms') }
        else if (event_option.email          === true) { history.push('/event/email') }
        else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
        else if (event_option.gif            === true) { history.push('/event/gif') }
        else if (event_option.social_media   === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }


    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Filters</p>
                                            <p className="mb-0 text-secondary">Set your filters</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handelFilter}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <ImEqualizer2 size={30} />
                                            <p className="mb-0 ml-2 font-size-16">Filter Library</p>
                                        </div>
                                        {
                                            emailTemplateErr &&
                                            <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any library</p>
                                        }
                                        <div className="float-right">
                                            <button type="button" className="btn btn-outline-primary" data-toggle="modal" data-target="#props-filter-modal">Select</button>

                                            <PropFilter setData={setPropFilterByProps} propFilterItem={propFilterItem} />
                                        </div>
                                    </div>
                                    <div className="prop__area">
                                        <div className="flex-wrap props-list d-flex justify-content-center">
                                            {
                                                propFilterItem.length > 0 ?
                                                    propFilterItem.map((propItem, index) => (
                                                        <div className="prop__item" key={`digital-props-index-${index}`}>
                                                            <img src={`${URL_S3}image/color_filter/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                            <span className="remove-props" onClick={removeProps.bind(this, index)}>
                                                                <IoTrashSharp />
                                                            </span>
                                                        </div>
                                                    ))

                                                    :
                                                    <div className="prop__no__item">
                                                        <h4>No Filter Selected.</h4>
                                                    </div>
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="my-4 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default Filter
